export enum GeneratedReportStatus {
    Pending = 0,
    Processing = 1,
    Completed = 2,
    Failed = 3,
}
